// extracted by mini-css-extract-plugin
export var activeLink = "header-module--activeLink--17e15";
export var burgerMenuIcon = "header-module--burgerMenuIcon--6d0b8";
export var connectbutton = "header-module--connectbutton--e34ba";
export var header = "header-module--header--ea1f1";
export var headerBlocker = "header-module--header-blocker--299fd";
export var headerTitle = "header-module--headerTitle--57240";
export var headerWrapper = "header-module--header-wrapper--4998e";
export var logo = "header-module--logo--ab863";
export var navContent = "header-module--navContent--f428e";
export var navElements = "header-module--navElements--ed987";
export var navHorizontal = "header-module--navHorizontal--e5655";
export var navLink = "header-module--navLink--f3359";
export var navLinks = "header-module--navLinks--50536";
export var navSideBar = "header-module--navSideBar--f43c7";
export var navSideBarBox = "header-module--navSideBarBox--3854a";
export var overlay = "header-module--overlay--b2123";
export var show = "header-module--show--51434";